import { Spin } from "antd"
import React from "react"

export default function StartupPage() {
  return (
    <Spin spinning size="large">
      <div className="page-full-wrapper" />
    </Spin>
  )
}
